import { GlobalLayout } from "@newsela/angelou";
import PropTypes from "prop-types";

import {
  utilityNavCss,
  getMainContentCss,
  getLayoutCss,
} from "./RegistrationLayout.style";
import UtilityNavContents from "./UtilityNavContents";

const propTypes = {
  mainContents: PropTypes.node,
  onBack: PropTypes.func,
  disableBack: PropTypes.bool,
  disableSignOut: PropTypes.bool,
  isCard: PropTypes.bool,
};

/**
 * @Deprecated The new layout version is now in @/registration/RegistrationLayout
 */
const RegistrationLayout = ({
  mainContents,
  onBack,
  disableBack,
  disableSignOut,
  isCard,
}) => {
  return (
    <GlobalLayout
      __renderUtilityNav={(props, Component) => (
        <Component {...props} css={utilityNavCss}>
          <UtilityNavContents
            onBack={onBack}
            disableBack={disableBack}
            disableSignOut={disableSignOut}
          />
        </Component>
      )}
      mainContents={<div css={getMainContentCss(isCard)}>{mainContents}</div>}
      __css={getLayoutCss(isCard)}
    />
  );
};

RegistrationLayout.propTypes = propTypes;

export default RegistrationLayout;
